import { handleActions } from 'redux-actions';

import { IntentActions } from '../../../actions/scenarios/intentAction.ts';

import type { IIntentClipboardState } from './IIntentClipboardState.ts';

const initialState: IIntentClipboardState = {
  intentClipboard: undefined,
  clipboardTargetId: undefined
};

export const intentClipboardReducer = handleActions<IIntentClipboardState>(
  {
    [IntentActions.Type.SET_INTENT_CLIPBOARD]: (state, action) => ({ ...action.payload })
  },
  initialState
);
